import { switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EmployeeInfoService } from '../../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { EmployeeService } from './../../../../pages/employee/services/employee.service';
import moment from 'moment';
import { CurrencyMaskInputMode } from "ngx-currency";
import { NgForm } from '@angular/forms';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ImageTransform } from 'ngx-image-cropper/lib/interfaces';
import { OrderByPipe } from './../../../../shared/pipe/order-by.pipe';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from 'src/app/core/services/event.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { WarningModalComponent } from 'src/app/modals/shared/warning-modal/warning-modal.component';
import { UtilityService } from '../../../../core/services/utility.service';
import { HomeService } from './../../../../pages/home/services/home.service';
import {
  PdfViewerComponent, LinkAnnotationService, BookmarkViewService, MagnificationService,
  ThumbnailViewService, ToolbarService, NavigationService, SignatureFieldSettings,
  AnnotationService, TextSearchService, TextSelectionService,
  PrintService, FormDesignerService, FormFieldsService, ValidateFormFieldsArgs
} from '@syncfusion/ej2-angular-pdfviewer';

@Component({
  selector: 'app-edit-expense-modal',
  templateUrl: './edit-expense-modal.component.html',
  styleUrls: ['./edit-expense-modal.component.css'],
  providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, SignatureFieldSettings,
    AnnotationService, TextSearchService, TextSelectionService,
    PrintService, FormDesignerService, FormFieldsService]
})
export class EditExpenseModalComponent implements OnInit {
  @Input() data: any;
  @Input() mode: string;
  @Input() selectedEmployee: any;
  @Input() where: string;
  public pdfviewerControl: PdfViewerComponent;
  @ViewChild('typeFields', { static: false }) typeFields: NgForm;
  portalSettings: any;
  orderByPipe: any;
  isOutOfBalance: boolean;
  exSubmitIndividualExpenseItem: boolean;
  preventSubmitNonCreditCard: boolean;
  mileageRateLabel: string;
  milesLabel: string;
  showTaxCodeOnMileage: boolean;
  currencySymbol: string;
  requireExpenseCodingForApproversOnly: boolean;
  exDisableLineRequireFields: boolean;
  switchDropdown: boolean;
  exEnabledEMCo: any;
  exEnabledGLCo: any;
  exEnabledJCCo: any;
  exEnabledSMCo: any;
  markAttachmentRequireBaseOnThreshold: any;
  requireAttachmentBasedOnMileage: boolean;
  showReviewer: boolean;
  mobileMode: boolean;
  saveInProgress: boolean;
  bindNewTaxCode: boolean;
  disableWhileSaving: boolean;
  format: string;
  formData: { [key: string]: any } = {};
  reimbursementList: any[];
  taxTypeList: { TaxType: number; TaxTypeDisplay: string; }[];
  ExpenseItemID: any;
  currentPRCo: any;
  showPending: boolean;
  showSaved: boolean;
  newFiles: any[];
  openModalLeft: number;
  savedFiles: any[];
  fieldsName: any[];
  groupedFields: any[];
  attachmentList: any[];
  umList: any[];
  itemDetails: { [key: string]: any } = {};
  isPR: boolean;
  lookupValues: { [key: string]: any } = {};
  lookupLoaded: { [key: string]: any } = {};
  itemDetailsCheck: { [key: string]: any } = {};
  lineTypeList: any[];
  reviewer: any[];
  reviewerList: any[];
  rateList: any[];
  taxCodeList: any[];
  creditList: any[];
  customerList: any[];
  employeeInfo: any;
  editNow: boolean;
  lastSave: { [key: string]: any } = {};
  catList: any[];
  cleanBoard: boolean;
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean };
  fileData: any[];
  close: string;
  fields: any[];
  fieldProperties: any[];
  earnCodeList: any[];
  innerCounter: number;
  alert: string;
  showTaxAmount: boolean;
  gettingLookupValues: boolean;
  options: { [key: string]: any } = {};
  submitting: boolean;
  aPCo: any;
  errorMsg: string;
  stopCalculate: boolean;//Unassigned variable
  restrictJCCO: any; //Unassigned variable
  canSave: boolean;
  extenion: any;
  showViewer: boolean;
  disableSaveImage: boolean;
  enableEditImage: boolean;
  imageSrc: any;
  uploadImage: string;
  searchText: string;
  croppedImage: any;
  canvasRotation: number;
  transform: ImageTransform = {};
  customerNameSearch = new Subject<any[]>();
  reviewerNameSearch = new Subject<any[]>();
  lookupValueSearch = new Subject<any[]>();
  lookupURL: string;
  lookupColumnName: string;
  preLoadLookup: boolean;
  selectFirstLookup: boolean;
  isMobileIos: any;
  transDateDaysLimit: string;
  isTransDateValid: boolean;
  service: any;

  constructor(public activeModal: NgbActiveModal, portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private employeeService: EmployeeService,
    public HttpClient: HttpClient, private eventService: EventService, private sharedModalService: BsModalService, private modalService: NgbModal, private utilityService: UtilityService, private homeService: HomeService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.format = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    this.service = "/Api/PdfViewer";
    this.orderByPipe = new OrderByPipe();
    this.datePickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false };
    this.editNow = false;
    this.formData.selectedReviewer = {};
    this.lastSave.status = null;
    this.lastSave.time = null;
    this.mileageRateLabel = this.portalSettings.CountryDateCode.ConfigValue === "CAN" || this.portalSettings.CountryDateCode.ConfigValue === "AU" ? "Rate / km" : "Mileage Rate";
    this.milesLabel = this.portalSettings.CountryDateCode.ConfigValue === "CAN" || this.portalSettings.CountryDateCode.ConfigValue === "AU" ? "Kilometers" : "Miles";
    this.showTaxCodeOnMileage = this.portalSettings.ShowTaxCodeOnMileage.ConfigValue === "1";

    var currencyFormatSymbols = this.portalSettings.CurrencyFormatPerPRCo.ConfigValue;
    this.currencySymbol = "$";
    if (currencyFormatSymbols && currencyFormatSymbols.trim() !== "") {
      currencyFormatSymbols.split(",").forEach((val: string) => {
        var arrayEntry = val.split(":");
        var currencyObject = { PRCo: parseInt(arrayEntry[0]), Currency: arrayEntry[1] }
        if (this.employeeInfo && currencyObject.PRCo == this.employeeInfo.PRCo) {
          this.currencySymbol = currencyObject.Currency;
        }
      });
    }
    this.transDateDaysLimit = this.portalSettings["EXRestrictTransactionDateNumberofDays"].ConfigValue;
    this.isTransDateValid = true;
    this.requireExpenseCodingForApproversOnly = this.portalSettings.RequireExpenseCodingForApproversOnly.ConfigValue == "1";
    this.exDisableLineRequireFields = this.portalSettings.ExDisableLineRequireFields.ConfigValue === "1";
    this.switchDropdown = this.portalSettings.SwitchJobToStandardSearchableDropdown.ConfigValue === "1";
    this.exEnabledEMCo = this.portalSettings.EXEnabledEMCo.ConfigValue != null ? this.portalSettings.EXEnabledEMCo.ConfigValue.split(",") : 0;
    this.exEnabledGLCo = this.portalSettings.EXEnabledGLCo.ConfigValue != null ? this.portalSettings.EXEnabledGLCo.ConfigValue.split(",") : 0;
    this.exEnabledJCCo = this.portalSettings.EXEnabledJCCo.ConfigValue != null ? this.portalSettings.EXEnabledJCCo.ConfigValue.split(",") : 0;
    this.exEnabledSMCo = this.portalSettings.EXEnabledSMCo.ConfigValue != null ? this.portalSettings.EXEnabledSMCo.ConfigValue.split(",") : 0;
    this.exSubmitIndividualExpenseItem = this.portalSettings.ExSubmitIndividualExpenseItem.ConfigValue == "1";
    this.markAttachmentRequireBaseOnThreshold = this.portalSettings.MarkAttachmentRequireBaseOnThreshold.ConfigValue;
    this.requireAttachmentBasedOnMileage = this.portalSettings.RequireAttachmentBasedOnMileage.ConfigValue == "1";
    this.preventSubmitNonCreditCard = this.portalSettings.PreventSubmitNonCreditCard.ConfigValue == "1";
    this.showReviewer = this.portalSettings.ReviewerOnSubmit.ConfigValue == "1" ? true : false;
    this.mobileMode = this.mobileAndTabletcheck();
    this.saveInProgress = false;
    this.where = this.where;
    this.bindNewTaxCode = false;
    this.disableWhileSaving = false;
    this.isOutOfBalance = this.data != null && this.data.ExpenseTransID != null && this.data.UnreconciledAmount != null;
    this.formData.UM = "LS";
    this.formData.ReimburseOrMileage = null;
    this.formData.CustomerName = null;
    this.formData.ExpenseTransID = null;
    this.formData.matchCreditCard = {};
    this.reimbursementList = [];
    this.taxTypeList = [{ TaxType: 0, TaxTypeDisplay: "No Tax Type" }, { TaxType: 1, TaxTypeDisplay: "1 - Sales" }, { TaxType: 2, TaxTypeDisplay: "2 - Use" }, { TaxType: 3, TaxTypeDisplay: "3 - VAT" }];
    this.ExpenseItemID = null;
    this.cleanBoard = true;
    if (this.where == "dashboard")
      this.cleanBoard = false;
    this.isMobileIos = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*(OS 11_0|OS 11_1|OS 11_2|OS 11_3)/i);
    if (this.isMobileIos != null) {
      $('body').addClass('iosBugFixCaret');
    }
    if (this.data != null) {
      this.currentPRCo = this.data.PRCo;
      this.ExpenseItemID = this.data.ExpenseItemID;
      for (let key in this.data) {
        let val = this.data[key];
        if (key === "Job") {
          this.formData["Job"] = {};
          this.formData["Job"].DatabaseValue = val;
          this.formData["JobLabel"] = val;
        } else
          this.formData[key] = val;
        this.formData.Amount = this.data.Amount;
      }
    } else {
      this.data = { ExpenseItemID: -1 };
      this.ExpenseItemID = -1;
      if (this.selectedEmployee !== null) {
        if (this.selectedEmployee.PRCo === null) {
          this.currentPRCo = this.employeeInfo.PRCo;
        } else {
          this.currentPRCo = this.selectedEmployee.PRCo;
        }
      } else {
        this.currentPRCo = this.employeeInfo.PRCo;
      }
    }

    if (this.formData.TransDate !== null)
      this.formData.TransDateDisplay = moment(this.formData.TransDate).utc().format(this.format);

    var temp = this.portalSettings.LimitReimbursementOnSubmit.ConfigValue.split(',');

    temp.forEach((val: string) => {
      if (val == "E") {
        this.reimbursementList.push({ value: "E", display: "Entertainment" });
      } else if (val == "R") {
        this.reimbursementList.push({ value: "R", display: "Expense" });
        if (this.formData.ReimburseOrMileage == null) {
          this.formData.ReimburseOrMileage = "R";
        }
      } else if (val == "M" && this.formData.ExpenseTransID == null) {
        this.reimbursementList.push({ value: "M", display: "Mileage" });
      }
    });

    if (this.formData.ReimburseOrMileage == null) {
      this.formData.ReimburseOrMileage = this.reimbursementList[0].value;
    }

    this.showPending = true;
    this.showSaved = true;
    this.newFiles = [];
    this.openModalLeft = (window.innerWidth - 200) / 2;
    this.savedFiles = [];
    this.attachmentList = [];
    this.itemDetails = {};
    for (let key in this.data) {
      this.itemDetails[key] = this.data[key];
    }

    if (this.itemDetails.Equip !== undefined) {
      this.formData.equipTempName = this.itemDetails.Equip;
    }
    if (this.itemDetails.Job !== undefined) {
      this.formData.jobTempName = this.itemDetails.Job;
    }
    if (this.itemDetails.Material !== undefined) {
      this.formData.materialTempName = this.itemDetails.Material;
    }
    if (this.itemDetails.SMWorkOrder !== undefined) {
      this.formData.smWorkOrderTempName = this.itemDetails.SMWorkOrder;
    }
    if (this.itemDetails.WO !== undefined) {
      this.formData.woTempName = this.itemDetails.WO;
    }

    this.formData.ExpenseDate = this.formData.ExpenseDate != null ? new Date(parseInt(moment(this.formData.ExpenseDate).utc().format("YYYY")), parseInt(moment(this.formData.ExpenseDate).utc().format("MM")) - 1, parseInt(moment(this.formData.ExpenseDate).utc().format("DD")), 0, 0, 0, 0) : new Date();

    if (this.selectedEmployee != null && this.selectedEmployee.DefaultBlankDate && this.ExpenseItemID == -1) {
      this.formData.ExpenseDate = null;
    }

    this.isPR = this.portalSettings.ExpensePostingType.ConfigValue.toLowerCase() == "p";
    this.lookupValues = {};
    this.lookupLoaded = [];
    this.itemDetailsCheck = {};
    this.lineTypeList = [];
    var lineTypeListCopy = {};
    var oriLineTypeList = {};
    oriLineTypeList["1"] = "Job";

    oriLineTypeList["3"] = "Expense";
    oriLineTypeList["4"] = "Equipment";
    oriLineTypeList["5"] = "EM Work Order";
    if (!this.isPR) {
      oriLineTypeList["6"] = "PO";
      
    }
    oriLineTypeList["8"] = "SM Work Order";

    this.portalSettings.ExpenseLineType.ConfigValue.split(",").forEach((val: string) => {
      if (oriLineTypeList.hasOwnProperty(val)) {
        this.lineTypeList.push({ index: parseInt(val), name: oriLineTypeList[val] });
        lineTypeListCopy[val] = true;
      }
    });

    if (lineTypeListCopy.hasOwnProperty(this.formData.LineChargeType))
      this.formData.LineChargeType = (this.formData.LineChargeType == null ? this.lineTypeList[0].index : this.formData.LineChargeType);
    else {
      this.clearField();
      this.formData.LineChargeType = this.lineTypeList[0].index;
    }
    this.openModal();
    this.getMileageList();
    this.getUM();
    this.getFieldsByLineItem();
    this.getCatg();

    if (this.formData.ExpenseTransID === null)
      this.getCreditCardList();

    if (this.mode !== "new")
      this.getAttachment();

    this.reviewer = [];
    this.reviewerList = [];
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: CurrencyMaskInputMode.NATURAL };
    this.typeSearch()
  }

  mobileAndTabletcheck() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check;
  }

  typeSearch() {
    this.customerNameSearch
      .pipe(
        switchMap(customerNameSearch => this.employeeService.getCustomerNames(this.formData.CustomerName))
      )
      .subscribe(data => {
        var response: any = data;
        var list: any[] = [];
        response.forEach((val: any, key: any) => {
          list.push({ Key: key, DisplayValue: val });
        });
        this.customerList = list;
      });

    this.reviewerNameSearch
      .pipe(
        switchMap(reviewerNameSearch => this.employeeService.getReviewers(this.formData.selectedReviewer.Label))
      )
      .subscribe(data => {
        var reviewer: any = data;
        this.reviewer = reviewer;
      });

    this.lookupValueSearch
      .pipe(
        switchMap(lookupValueSearch => this.employeeService.getlookupURL(this.lookupURL))
      )
      .subscribe(data => {
        var response: any = data;
        if (this.preLoadLookup && response.length == 1)
          return this.setLookUps(this.lookupColumnName, true, response);
        else if (!this.preLoadLookup)
          return this.setLookUps(this.lookupColumnName, this.selectFirstLookup, response);
      });

  }

  searchReviewer() {
    if (this.formData.selectedReviewer.Label != null && this.formData.selectedReviewer.Label.length > 1) {
      this.reviewerNameSearch.next();
    }
  }

  addReviewer() {
    this.reviewerList.push({ reviewer: this.formData.selectedReviewer.Value, reviewerName: this.formData.selectedReviewer.Label });
    this.formData.selectedReviewer = {};
  }

  removeReviewer(index: any) {
    this.reviewerList.splice(index, 1);
  }

  getCreditCardList() {
    this.employeeService.getCreditCardList(this.selectedEmployee).then((response: any) => {
      this.creditList = response;
      if (this.creditList != null) {
        this.creditList.forEach((val: any) => {
          if (val.TransDate !== null)
            val.TransDateDisplay = moment(val.TransDate).utc().format(this.format);
          val.displayValue = val.TransDateDisplay + " " + val.TransDescription + " " + this.currencySymbol + val.TransAmount;
        });
      }
    })
  }

  unlinkCreditCard() {
    this.openModal();
    this.employeeService.unlinkItem(this.selectedEmployee === null ? null : this.selectedEmployee.UserKeyID, this.ExpenseItemID).then((response: any) => {
      this.cleanBoard = false;
      if (response.success) {
        this.formData.ExpenseTransID = null;
        this.getCreditCardList();
        this.formData.matchCreditCard = null;
        this.isOutOfBalance = false;
      }
      this.closeModal();
    });
  };

  getMileageList() {
    this.employeeService.getMileageRate(this.currentPRCo).then((response: any) => {
      this.rateList = response;
      this.rateList.forEach((val: any) => {
        if (val.MileageRate.toFixed(2).length > val.MileageRate.toString().length)
          val.mileageRateDisplay = val.MileageRate.toFixed(2);
        else
          val.mileageRateDisplay = val.MileageRate;
      });
      if (this.rateList.length > 0) {
        if (this.formData.ReimburseOrMileage == "M") {
          var rateExist = false;
          if (this.formData.UnitCost != null) {
            this.rateList.forEach((val: any) => {
              if (val.MileageRate == this.formData.UnitCost) {
                rateExist = true;
              }
            });
          }
          if (!rateExist)
            this.formData.UnitCost = this.rateList[0].MileageRate;
        }
      }
      this.getCompanySetting();
    });
  }

  getCompanySetting() {
    this.employeeService.expenseSettingsByPRCo(this.currentPRCo).then((response: any) => {
      if (this.mode == "new") {
        if (this.portalSettings["CountryDateCode"].ConfigValue == "US") {
          this.formData.TaxType = 1;
        }
        else {
          this.formData.TaxType = 3;
        }

        if (this.portalSettings["ExpenseTaxTypeDefaultOverride"].ConfigValue != null)
          this.formData.TaxType = parseInt(this.portalSettings["ExpenseTaxTypeDefaultOverride"].ConfigValue);
      }

      this.showTaxAmount = response[0].ShowTaxAmount;
      this.aPCo = response[0].APCo;

      if ((this.mode == "new" || this.formData.TaxCode == null) && this.formData.TaxType != 0) {
        if(this.formData.ReimburseOrMileage != 'M' || (this.formData.ReimburseOrMileage == 'M' && this.showTaxCodeOnMileage)){
          this.formData.TaxCode = response[0].TaxCode;        
          this.bindNewTaxCode = true;
        }
      }

      if (this.formData.TaxType != 0) {
        this.getTaxCode();
      }
    });
  }

  getTaxCode() {
    this.employeeService.getTaxCodes(this.formData.TaxType).then((response: any) => {
      this.taxCodeList = response;
      this.taxCodeList.unshift({ EffectiveRate: 0, TaxCode: null, TaxCodeDisplay: "No Tax Code" });
      if (this.formData.TaxCode != null) {
        var count = 0;
        response.forEach((val: any) => {
          if (val.TaxCode == this.formData.TaxCode)
            count++;
        });
        if (count == 0)
          this.formData.TaxCode = null;
      }
      if (this.formData.Amount != null && this.showTaxAmount && this.taxCodeList.length > 0 && (this.formData.TaxAmount == null || this.bindNewTaxCode)) {
        this.calculateTaxAmount();
        this.bindNewTaxCode = false;
      }
      if (this.formData.ReimburseOrMileage == "M") {
        this.calculatMileage();
      }
    });
  }

  calculatMileage() {
    if (this.formData.UnitCost != null && this.formData.Units != null)
      this.formData.MileTotal = this.formData.UnitCost * this.formData.Units;
    else
      this.formData.MileTotal = null;

    if (this.formData.MileTotal != null && this.formData.TaxCode != null && this.taxCodeList != null)
      this.calculateCanTaxAmount();
    this.saveItem('open');
  }

  calculateCanTaxAmount() {
    if (this.formData.MileTotal != null && this.formData.TaxCode != null) {
      var tempRate = null;

      this.taxCodeList.forEach((val: any) => {
        if (this.formData.TaxCode == val.TaxCode)
          tempRate = val.EffectiveRate;
      });
      if (this.formData.TaxType == 2)
        this.formData.TaxAmount = this.formData.MileTotal * tempRate;
      else
        this.formData.TaxAmount = (this.formData.MileTotal / (1 + tempRate)) * tempRate;
    } else
      this.formData.TaxAmount = null;
  }

  calculateTaxAmount() {
    if (this.formData.Amount != null && this.formData.TaxCode != null) {
      var tempRate = null;
      this.taxCodeList.forEach((val: any) => {
        if (this.formData.TaxCode == val.TaxCode)
          tempRate = val.EffectiveRate;
      });
      if (this.formData.TaxType == 2)
        this.formData.TaxAmount = this.formData.Amount * tempRate;
      else
        this.formData.TaxAmount = (this.formData.Amount / (1 + tempRate)) * tempRate;
    } else
      this.formData.TaxAmount = null;
  }

  amountChange(where: string) {
    if (where === "amount") {
      if (isNaN(this.formData.Amount)) {
        this.formData.Amount = null;
      } else {
        if (this.formData.Amount !== null && this.showTaxAmount && this.formData.TaxCode !== null) {
          var tempRate = null;
          this.taxCodeList.forEach((val: any) => {
            if (this.formData.TaxCode === val.TaxCode)
              tempRate = val.EffectiveRate;
          });
          if (this.formData.TaxType == 2)
            this.formData.TaxAmount = this.formData.Amount * tempRate
          else
            this.formData.TaxAmount = this.formData.Amount / (1 + tempRate) * tempRate;
        } else
          this.formData.TaxAmount = null;
      }
      this.isOutOfBalance = this.formData.ExpenseTransID != null && (this.formData.Amount != null && this.formData.Amount != this.formData.matchCreditCard.UnreconciledAmount);
    } else {
      if (isNaN(this.formData.TaxAmount)) {
        this.formData.TaxAmount = null;
      }
    }
    this.saveItem('open');
  }

  getCatg() {
    this.employeeService.getCategory().then((response: any) => {
      this.catList = [];
      response.forEach((val: any) => {
        if (val.IsActive)
          this.catList.push(val);
      });
    });
    this.closeModal();
  }

  readFile(file, call) {
    var reader = new FileReader();
    reader.onload = function (e) { return call(e, file.name) };
    reader.readAsDataURL(file);
  }

  getCustomerNamesSearch() {
    if (this.formData.CustomerName != null && this.formData.CustomerName.length >= 2) {
      this.customerNameSearch.next();
    }
  }

  blurSave() {
    this.cleanBoard = false;
    this.saveItem('open');
  }

  calculatTotal(saveTrigger: boolean) {
    if (this.formData.Units != null && this.formData.UnitCost != null && !isNaN(this.formData.UnitCost)) {
      this.formData.Amount = this.formData.Units * this.formData.UnitCost;
      this.amountChange("amount");
    }
    if (saveTrigger)
      this.saveItem('open');
  }

  rorMUpdate() {
    if (this.formData.ReimburseOrMileage == "M") {
      this.formData.UM = null;
      this.formData.Units = null;
      this.formData.TaxCode = null;
      this.formData.TaxAmount = null;
      this.formData.MileTotal = null;
      this.formData.UnitCost = null;
      this.formData.Amount = null;
      this.formData.CustomerName = null;
      this.formData.CustomerCount = null;
      this.formData.OurFirmCount = null;
    } else if (this.formData.ReimburseOrMileage == "R") {
      this.formData.CustomerName = null;
      this.formData.CustomerCount = null;
      this.formData.OurFirmCount = null;
      this.calculatTotal(false);
    } else {
      this.calculatTotal(false);
    }

    this.saveItem('open');
  }

  saveItem(close: string) {
    if (this.ExpenseItemID == -1) {
      this.disableWhileSaving = true;
    }

    if (this.formData.ExpenseDate != null && this.transDateDaysLimit != null && this.employeeInfo != null) {
      var transDate = moment(this.formData.ExpenseDate).format(this.format);
      var restrictedTransDate = moment(new Date()).subtract(this.transDateDaysLimit, "days").format(this.format);
      if (transDate < restrictedTransDate && !this.employeeInfo.IsExpenseAdmin) {
        this.isTransDateValid = false;
        this.disableWhileSaving = false;
      }
      else if (transDate < restrictedTransDate && this.employeeInfo.IsExpenseAdmin && close == 'submit') {
        const initialState = {
          modalData: {
            modalTitle: "Confirm Message",
            modalMessage: 'Transaction date is beyond allowed expense date.  Are you sure you want to continue?',
            modalAction: "Continue", closeButtonText: "Cancel", warningLevel: "success"
          },
          backdrop: 'static',
          size: 'md'
        };
        let modalRef = this.sharedModalService.show(WarningModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
        modalRef.onHide.subscribe((reason: any) => {
          var result = modalRef.content;
          if (result.userAction == "Continue") {
            this.saveDetail(close);
          }
        });
      }
      else {
        this.isTransDateValid = true;
        this.disableWhileSaving = false;
        this.saveDetail(close);
      }
    }
    else {
      this.saveDetail(close);
    }
  }

  saveDetail(close: string) {
  this.saveInProgress = true;
  if (((this.showTaxAmount && ((Math.abs(this.formData.TaxAmount) <= Math.abs(this.formData.Amount) && this.formData.Amount != null && this.formData.TaxAmount != null) ||
    (this.formData.Amount != null && this.formData.TaxAmount == null) && (this.formData.ReimburseOrMileage == "R" || this.formData.ReimburseOrMileage == "E")) || this.formData.ReimburseOrMileage == "M") || !this.showTaxAmount)
    && (this.formData.Description != null && this.formData.Description != '') && (this.typeFields.form.valid || this.exDisableLineRequireFields) &&
    ((this.formData.Amount != null && this.formData.Amount != '' && (this.formData.ReimburseOrMileage == "R" || this.formData.ReimburseOrMileage == "E")) ||
      (this.formData.ReimburseOrMileage == "M" && (this.formData.UnitCost != null && this.formData.Units != null)))
    && (this.formData.LineChargeType != 4 || this.itemDetails.Equip != null || this.exDisableLineRequireFields) && (this.selectedEmployee != null ? (!this.selectedEmployee.DefaultBlankDate || (this.selectedEmployee.DefaultBlankDate && this.formData.ExpenseDate != null)) : this.formData.ExpenseDate != null)) {
    this.employeeService.insertUpdateExpenseItem(
      this.ExpenseItemID,
      this.formData.ExpenseCatgID,
      this.formData.Description,
      this.formData.Amount,
      this.formData.TaxAmount,
      this.formData.Vendor,
      this.itemDetails.JCCo,
      this.itemDetails.Job,
      this.selectedEmployee === null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID,
      this.formData.CustomerName,
      this.itemDetails.Phase,
      this.itemDetails.GLCo,
      this.itemDetails.GLAcct,
      this.itemDetails.SMCo,
      this.itemDetails.SMWorkOrder,
      this.itemDetails.EMCo,
      this.formData.Units,
      (this.formData.ReimburseOrMileage === "M" ? "EA" : this.formData.UM),
      this.formData.UnitCost,
      moment(this.formData.ExpenseDate, this.format).format("YYYY-MM-DD"),
      this.formData.ReimburseOrMileage,
      this.formData.CustomerCount,
      this.formData.OurFirmCount,
      this.formData.Note,
      this.itemDetails.JCCType,
      (this.selectedEmployee === null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID),
      this.formData.TaxCode,
      this.itemDetails.PO,
      this.itemDetails.POItem,
      this.itemDetails.SL,
      this.itemDetails.SLItem,
      this.itemDetails.WO,
      this.itemDetails.WOItem,
      this.itemDetails.Equip,
      this.itemDetails.CostCode,
      this.itemDetails.EMCType,
      this.itemDetails.CompType,
      this.itemDetails.Component,
      this.itemDetails.INCo,
      this.itemDetails.Loc,
      this.itemDetails.Material,
      this.itemDetails.Scope,
      this.itemDetails.POItemLine,
      this.itemDetails.SMCostType,
      this.formData.LineChargeType,
      this.itemDetails.EarnCode,
      this.formData.AttendeeName,
      this.formData.TaxType == 0 ? null : this.formData.TaxType
    ).then((response: any) => {
      this.fadeLabel(response.success);
      this.cleanBoard = false;
      if (this.ExpenseItemID == -1) {
        this.ExpenseItemID = response.newID;
        this.mode = "edit";
      }
      if (this.newFiles.length > 0) {
        this.attachmentUpload(response.newID, close);
      }
      this.disableWhileSaving = false;
      this.saveInProgress = false;
      if (close == "close") {
        this.activeModal.close();
      } else if (close == 'submit') {
        this.submitItem();
      }
    });
  } else {
    if (close == 'close') {
      this.closeModal();
    } else if (close == 'submit') {
      this.submitItem();
    }
    this.disableWhileSaving = false;
    this.saveInProgress = false;
  }
}

  submitItem() {
    this.submitting = true;
    this.employeeService.submitItems(this.ExpenseItemID, this.formData.Description, this.selectedEmployee == null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID).then((response: any) => {
      this.eventService.broadcast('approvedExpenseChangedBroadcast');
      var reviewerArray = [];
      this.reviewerList.forEach((val: any) => {
        reviewerArray.push(val.reviewer.Reviewer);
      });
      if (reviewerArray.length > 0) {
        this.employeeService.addReviewer(response.newID, reviewerArray).then((response: any) => {
          this.activeModal.close(response.success);
        });
      } else {
        this.activeModal.close(response.success);
      }
    });
  }

  clearField() {
    for (let key in this.itemDetails) {
      this.itemDetails[key] = null;
    }
    this.formData.equipTempName = null;
    this.formData.jobTempName = null;
    this.formData.materialTempName = null;
    this.formData.smWorkOrderTempName = null;
    this.formData.woTempName = null;
    this.formData.equipTemp = null;
    this.formData.jobTemp = null;
    this.formData.materialTemp = null;
    this.formData.smWorkOrderTemp = null;
    this.formData.woTemp = null;
  }

  typeChanged() {
    this.clearField();
    this.getFieldsByLineItem();
    //#435764: Saving item on type change
    this.saveItem('open');
  }

  getFieldsByLineItem() {
    this.openModal();
    this.employeeService.getFieldsByLineItem(this.formData.LineChargeType, null).then((response: any) => {
      this.fields = response;
      this.lookupValues = {};
      this.fieldProperties = [];
      this.itemDetailsCheck = {};
      this.fields.forEach((val: any) => {
        this.fieldProperties[val.ColumnName] = {};
        this.fieldProperties[val.ColumnName].Visible = true;
        this.fieldProperties[val.ColumnName].Required = val.Req;
        if (val.ColumnName == "UM")
          this.fieldProperties[val.ColumnName].Required = true;
        if (val.ColumnName != "Description" && !((val.ColumnName == "GLCo" || val.ColumnName == "GLAcct") && !this.formData.ExpenseTransID && this.isPR) &&
          !(val.ColumnName == "Material" && this.formData.LineChargeType != 2)) {
          this.itemDetailsCheck[val.ColumnName] = val.Req;
        }
        if (this.lookupValues[val.ColumnName] == null) {
          this.lookupValues[val.ColumnName] = [];
        }
      });
      if (this.formData.LineChargeType == 3 && !this.formData.ExpenseTransID && this.isPR) {
        this.fields.push({ FieldLabel: "EarnCode", ColumnName: "EarnCode", Req: "true", IsCombo: 1 });
        this.fieldProperties["EarnCode"] = {};
        this.fieldProperties["EarnCode"].Visible = true;
        this.fieldProperties["EarnCode"].Required = true;
        this.itemDetailsCheck["EarnCode"] = true;
        this.getEarnCodes();
      }

      if (this.formData.LineChargeType == 1)
        this.loadValues("JCCo", null, null, null, true);
      else if (this.formData.LineChargeType == 3)
        this.loadValues("GLCo", null, null, null, true);
      else if (this.formData.LineChargeType == 4 || this.formData.LineChargeType == 5)
        this.loadValues("EMCo", null, null, null, true);
      else if (this.formData.LineChargeType == 8)
        this.loadValues("SMCo", null, null, null, true);

      this.closeModal();
      if (this.formData.LineChargeType == 6 && this.itemDetails.ItemType != null) {
        this.getPOFields('');
      }
      else {
        this.groupFields();
      }
    });
  }

  loadValues(columnName: string, selectFirst?: boolean, searchText?: string, isSuper?: any, preload?: boolean) {
    this.gettingLookupValues = true;
    this.preLoadLookup = preload;
    this.lookupColumnName = columnName;
    this.selectFirstLookup = selectFirst;
    var tempPOCo = null;
    if (this.formData.LineChargeType == 6 && this.itemDetails.PO != null) {
      this.lookupValues["PO"].forEach((val: any) => {
        if (val.DatabaseValue == this.itemDetails.PO) {
          tempPOCo = val.POCo;
        }
      })
    }

    this.lookupURL = "/employee/GetLookups?columnName="
      + columnName
      + "&lineType=" + this.formData.LineChargeType
      + (!this.itemDetails.JCCo || this.itemDetails.JCCo === undefined ? '' : "&jCCo=" + this.itemDetails.JCCo)
      + (!this.itemDetails.Job || this.itemDetails.Job === undefined ? '' : "&job=" + encodeURIComponent(this.itemDetails.Job))
      + (!this.itemDetails.Phase || this.itemDetails.Phase === undefined ? '' : "&phase=" + encodeURIComponent(this.itemDetails.Phase))
      + (!this.itemDetails.JCCType || this.itemDetails.JCCType === undefined ? '' : "&jCCType=" + this.itemDetails.JCCType)
      + (!this.itemDetails.Material || this.itemDetails.Material === undefined ? '' : "&material=" + encodeURIComponent(this.itemDetails.Material))
      + (!this.itemDetails.Description || this.itemDetails.Description === undefined ? '' : "&description= " + encodeURIComponent(this.itemDetails.Description))
      + (!this.itemDetails.GLCo || this.itemDetails.GLCo === undefined ? '' : "&gLCo=" + this.itemDetails.GLCo)
      + (!this.itemDetails.INCo || this.itemDetails.INCo === undefined ? '' : "&iNCo=" + this.itemDetails.INCo)
      + (!this.itemDetails.EMCo || this.itemDetails.EMCo === undefined ? '' : "&eMCo=" + this.itemDetails.EMCo)
      + (!this.itemDetails.Equip || this.itemDetails.Equip === undefined ? '' : "&equip=" + this.itemDetails.Equip)
      + (!this.itemDetails.CompType || this.itemDetails.CompType === undefined ? '' : "&compType=" + this.itemDetails.CompType)
      + (!this.itemDetails.CostCode || this.itemDetails.CostCode === undefined ? '' : "&costCode=" + this.itemDetails.CostCode)
      + (!this.itemDetails.WO || this.itemDetails.WO === undefined ? '' : "&wO=" + this.itemDetails.WO)
      + (!this.itemDetails.WOItem || this.itemDetails.WOItem === undefined ? '' : "&wOItem=" + this.itemDetails.WOItem)
      + (!this.aPCo || this.aPCo === undefined ? '' : "&pOCo=" + ((this.formData.LineChargeType == "6" && tempPOCo != null) ? tempPOCo : this.aPCo))
      + (!this.itemDetails.Loc || this.itemDetails.Loc === undefined ? '' : "&loc=" + this.itemDetails.Loc)
      + (!this.itemDetails.SMCo || this.itemDetails.SMCo === undefined ? '' : "&sMCo=" + this.itemDetails.SMCo)
      + (!this.itemDetails.SMWorkOrder || this.itemDetails.SMWorkOrder === undefined ? '' : "&sMWorkOrder=" + this.itemDetails.SMWorkOrder)
      + (!this.itemDetails.PO || this.itemDetails.PO === undefined ? '' : "&pO=" + this.itemDetails.PO)
      + (!this.itemDetails.POItem || this.itemDetails.POItem === undefined ? '' : "&pOItem=" + this.itemDetails.POItem)
      + (!this.itemDetails.POItemLine || this.itemDetails.POItemLine === undefined ? '' : "&pOItemLine=" + this.itemDetails.POItemLine)
      + (!this.itemDetails.SMScope || this.itemDetails.SMScope === undefined ? '' : "&sMScope=" + this.itemDetails.SMScope)
      + "&userKeyID=" + (this.selectedEmployee == null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID)
      + "&expenseItemId=" + this.ExpenseItemID;

    if (columnName == "PO")
      this.lookupURL = "/employee/GetPOLookup?userKeyID=" + (this.selectedEmployee == null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID) + "&expenseItemID=" + this.ExpenseItemID;

    if (searchText !== null && searchText !== undefined) {
      this.lookupURL += "&searchText=" + searchText;
    }

    if (isSuper && isSuper !== undefined) {
      this.lookupValueSearch.next();
    }
    else {
      this.lookupValueSearch.next();
    }
  }

  setLookUps(columnName: string, selectFirst: boolean, response: any) {
    this.gettingLookupValues = false;
    this.lookupValues[columnName] = [];
    this.lookupValues[columnName] = response;
    //place null value for clearing
    if (this.exDisableLineRequireFields || !this.fieldProperties[columnName].Required)
      this.lookupValues[columnName].unshift({ DatabaseValue: null, DisplayValue: "No " + columnName, POCo: null });
    this.lookupLoaded[columnName] = true;
    if (columnName == "PO") {
      response.forEach((val: any) => {
        if (val.POCo != null)
          val.DisplayValue = val.POCo + " - " + val.DisplayValue;
      });
    }
    if (selectFirst && this.lookupValues[columnName].length > 0 && this.itemDetails[columnName] == null) {
      //242741: If portal setting - Company Restrictions is assigned with only one Company code, then default them in corresponding combo box.
      if (((this.exEnabledEMCo.length == 1 && columnName == "EMCo") || (this.exEnabledGLCo.length == 1 && columnName == "GLCo") || (this.exEnabledJCCo.length == 1 && columnName == "JCCo") || (this.exEnabledSMCo.length == 1 && columnName == "SMCo")) && this.lookupValues[columnName].length == 2) {
        this.itemDetails[columnName] = this.lookupValues[columnName][1].DatabaseValue;
      }
      else {
        this.itemDetails[columnName] = this.lookupValues[columnName][0].DatabaseValue;
      }
      this.fieldChanged({ ColumnName: columnName });
    } else {
      if (columnName == "JCCo" || columnName == "GLCo" || columnName == "JCCType") {
        var checkCount = 0;

        response.forEach((val: any) => {
          if ((parseInt(val.DatabaseValue) == this.itemDetails.JCCo && columnName == "JCCo") || (parseInt(val.DatabaseValue) == this.itemDetails.GLCo && columnName == "GLCo")
            || (parseInt(val.DatabaseValue) == this.itemDetails.JCCType && columnName == "JCCType")) {
            this.itemDetails[columnName] = val.DatabaseValue;
            checkCount++;
          }
        });
        if (checkCount == 0) {
          if (this.exDisableLineRequireFields || !this.fieldProperties[columnName].Required) {
            if (this.lookupValues[columnName].length == 2) {
              this.itemDetails[columnName] = this.lookupValues[columnName][1].DatabaseValue;
            }
          } else {
            if (this.lookupValues[columnName].length == 1) {
              this.itemDetails[columnName] = this.lookupValues[columnName][0].DatabaseValue;
            }
          }
          if (columnName == "JCCType")
            this.fieldChanged({ ColumnName: columnName });
        }

      }
    }
  }

  getPOFields(newValues: any) {
    var oldPOFields = this.fields;
    this.itemDetailsCheck = {};
    this.employeeService.getFieldsByLineItem(this.formData.LineChargeType, this.itemDetails["ItemType"]).then((response: any) => {
      this.fields = response;
      //if the old field no longer exists, delete the value
      oldPOFields.forEach((oldField: any) => {
        var fieldFound = false;
        this.fields.forEach((newField: any) => {
          if (oldField.ColumnName == newField.ColumnName) {
            fieldFound = true;
            return false;
          }
          this.itemDetailsCheck[newField.ColumnName] = newField.Req;
        });
        if (!fieldFound) {
          this.itemDetails[oldField.ColumnName] = null;
        }
        this.lookupValues[oldField.ColumnName] = [];
        this.lookupLoaded[oldField.ColumnName] = false;
      });
      if (newValues != '')
        this.bindPOValues(newValues);
      else
        this.groupFields();
    });
  }

  bindPOValues(newValues: any) {
    this.fields.forEach((field: any) => {
      var columnName = field.ColumnName;
      if (columnName != "PO" && columnName != "POItem" && columnName != "POItemLine") {
        this.itemDetails[field.ColumnName] = newValues[field.ColumnName];
      }
      if (columnName == "Job") {
        this.formData.jobTemp = newValues.Job;
        this.formData.jobTempName = newValues.Job;
      }
      if (columnName == "Phase") {
        this.formData.phaseTemp = newValues.Phase;
        this.formData.phaseTempName = newValues.Phase;
      }
      if (columnName == "Equip") {
        this.formData.equipTemp = newValues.Equip;
        this.formData.equipTempName = newValues.Equip;
      }
      if (columnName == "Material") {
        this.formData.materialTemp = newValues.Material;
        this.formData.materialTempName = newValues.Material;
      }
      if (columnName == "SMWorkOrder") {
        this.formData.smWorkOrderTemp = newValues.SMWorkOrder;
        this.formData.smWorkOrderTempName = newValues.SMWorkOrder;
      }
      if (columnName == "WO") {
        this.formData.woTemp = newValues.WO;
        this.formData.woTempName = newValues.WO;
      }
      if (columnName != "PO") {
        this.lookupValues[field.ColumnName] = [];
        this.lookupLoaded[field.ColumnName] = false;
      }
    });

    //Amounts
    this.formData.UM = null;
    for (let val in this.lookupValues.UM) {
      if (this.lookupValues.UM[val].DatabaseValue == newValues.UM) {
        this.formData.UM = newValues.UM;
      }
    }
    this.formData.UnitCost = newValues.CurUnitCost;
    if (!this.stopCalculate) {
      this.formData.Units = newValues.CurUnits;
      this.formData.Amount = newValues.TotalCost;
      this.formData.ECM = newValues.CurECM;
      if (newValues.TaxCode !== null) {
        this.formData.TaxCode = newValues.TaxCode;
        this.formData.TaxType = newValues.TaxType;
        this.getTaxCode();
        this.formData.TaxBasis = newValues.TotalCost;
        this.formData.TaxAmt = newValues.TotalTax;
      } else {
        this.formData.TaxCode = null;
        this.formData.TaxType = null;
        this.taxCodeList = [];
        this.formData.TaxBasis = 0;
        this.formData.TaxAmt = 0;
      }
    } else if (this.formData.UM != "LS" && this.stopCalculate) {
      this.formData.Units = this.formData.Amount / newValues.CurUnitCost;
    } else if (this.formData.UM == "LS") {
      this.formData.UnitCost = 0;
      this.formData.Units = 0;
    }
  }

  getEarnCodes() {
    this.openModal();
    this.employeeService.getEarnCodes(this.currentPRCo).then((response: any) => {
      this.earnCodeList = response;
      response.forEach((val: any) => {
        if (val.IsDefault)
          this.formData.SelectedEarnCode = val.EarnCode;
      })
      this.closeModal();
    });
  }

  groupFields() {
    this.fieldsName = [];
    this.groupedFields = [];
    var group = [];
    for (var i = 0; i < this.fields.length; i++) {
      if (group.length == 20) {
        this.groupedFields.push(group);
        group = [];
        if (this.fieldProperties[this.fields[i].ColumnName] != null) {
          if (this.fieldProperties[this.fields[i].ColumnName].Visible && this.fields[i].ColumnName != "ItemType")
            group.push(this.fields[i]);
        }
      }
      else {
        if (this.fieldProperties[this.fields[i].ColumnName] != null) {
          if (this.fieldProperties[this.fields[i].ColumnName].Visible && this.fields[i].ColumnName != "ItemType")
            group.push(this.fields[i]);
        }
      }
      if (this.fieldProperties[this.fields[i].ColumnName] != null) {
        if (this.fieldProperties[this.fields[i].ColumnName].Visible && this.fields[i].ColumnName != "ItemType")
          this.fieldsName.push({ name: this.fields[i].ColumnName });
      }
    }
    if (group.length != 0) {
      this.groupedFields.push(group);
    }
    this.populateFields();
  }

  populateFields() {
    var savedData = {};
    this.fields.forEach((val: any) => {
      if (val.ColumnName !== "Description" && !((val.ColumnName === "GLCo" || val.ColumnName === "GLAcct") && this.isPR) &&
        !(val.ColumnName === "Material" && this.formData.LineChargeType !== 2)) {
        if (this.itemDetails[val.ColumnName]) {
          savedData[val.ColumnName] = this.itemDetails[val.ColumnName];
        }
        else {
          savedData[val.ColumnName] = null;
        }
        if (val.ColumnName === 'Equip') {
          this.formData.equipTemp = savedData[val.ColumnName];
          this.formData.equipTempname = savedData[val.ColumnName];
        }
        if (val.ColumnName === 'Job') {
          this.formData.jobTemp = savedData[val.ColumnName];
          this.formData.jobTempName = savedData[val.ColumnName];
        }
        if (val.ColumnName === 'Material') {
          this.formData.materialTemp = savedData[val.ColumnName];
          this.formData.materialTempName = savedData[val.ColumnName];
        }
        if (val.ColumnName === 'SMWorkOrder') {
          this.formData.smWorkOrderTemp = savedData[val.ColumnName];
          this.formData.smWorkOrderTempName = savedData[val.ColumnName];
        }
        if (val.ColumnName === 'WO') {
          this.formData.woTemp = savedData[val.ColumnName];
          this.formData.woTempName = savedData[val.ColumnName];
        }
      }
    });
    //274187 - Ensure Empty data is not assigned for other Line Types
    if (Object.keys(savedData).length != 0) {
      this.itemDetails = savedData;
    }
    this.willSave();
    if (this.restrictJCCO) {
      this.fields.forEach((val: any) => {
        if ((val.ColumnName === "JCCo" || val.ColumnName === "GLCo"))
          this.loadValues(val.ColumnName, false, null);
      });
    }
  }

  getUM() {
    this.employeeService.getLookups().then((response: any) => {
      this.umList = response;
    });
  }

  pendingTrigger() {
    this.showPending = !this.showPending;
  }

  savedTrigger() {
    this.showSaved = !this.showSaved;
  }

  cancelClicked() {
    if (this.cleanBoard)
      this.activeModal.dismiss();
    else {
      this.activeModal.close();
    }
  }

  creditCardAction() {
    this.openModal();
    this.employeeService.transAction(this.formData.matchCreditCard.ExpenseTransID, (this.selectedEmployee === null ? null : this.selectedEmployee.UserKeyID), "M", this.ExpenseItemID, null).then((response: any) => {
      this.cleanBoard = false;
      this.formData.ExpenseTransID = this.formData.matchCreditCard.ExpenseTransID;
      this.formData.TransDateDisplay = this.formData.matchCreditCard.TransDateDisplay;
      this.formData.TransVendor = this.formData.matchCreditCard.TransVendor;
      this.formData.TransDescription = this.formData.matchCreditCard.TransDescription;
      this.formData.TransAmount = this.formData.matchCreditCard.TransAmount;
      this.isOutOfBalance = this.formData.Amount != this.formData.matchCreditCard.UnreconciledAmount;
      this.isOutOfBalance = this.formData.Amount != this.formData.matchCreditCard.UnreconciledAmount;

      this.lookupValues["PO"] = [];
      this.lookupValues["POItem"] = [];
      this.lookupValues["POItemLine"] = [];
      this.itemDetails.PO = null;
      this.itemDetails.POItem = null;
      this.itemDetails.POItemLine = null;

      this.closeModal();
    });
  };

  getAttachment() {
    this.savedFiles = [];
    this.newFiles = [];
    this.employeeService.getLineAttachments(this.ExpenseItemID).then((response: any) => {
      this.savedFiles = response;
      if (this.savedFiles && this.savedFiles.length > 0) {
        this.formData.selectedAttachment = this.savedFiles[0];
      }
      this.attachmentList = [];
      this.savedFiles.forEach((val: any) => {
        var tempExten = val.AttachmentFileName.substr(val.AttachmentFileName.lastIndexOf("."), val.AttachmentFileName.length);
        if (tempExten.toLowerCase() === ".jpg" || tempExten.toLowerCase() === ".jpeg" || tempExten.toLowerCase() === ".png" || tempExten.toLowerCase() === ".tif" || tempExten.toLowerCase() === ".tiff")
          this.attachmentList.push(val);
        this.attachmentChange();

      });

      this.closeModal();
    });
  }

  attachmentChange() {
    this.extenion = this.formData.selectedAttachment.AttachmentFileName.substr(this.formData.selectedAttachment.AttachmentFileName.lastIndexOf("."), this.formData.selectedAttachment.AttachmentFileName.length);
    if (this.utilityService.checkFileExtension(this.extenion)) {
      this.showViewer = true;
      this.homeService.getPdfData(this.formData.selectedAttachment.FileAttachmentID).then((response: any) => {
        var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
        pdfviewer.toolbar.showToolbarItem(new Array("SubmitForm"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("OpenOption"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("CommentTool"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("PrintOption"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("AnnotationEditTool"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("FormDesignerEditTool"), false);
        pdfviewer.documentPath = "data:application/pdf;base64," + (response);
        pdfviewer.downloadFileName = this.formData.selectedAttachment.AttachmentFileName.substring(0, this.formData.selectedAttachment.AttachmentFileName.indexOf('.')) + ".pdf";
      }).catch((error: any) => {

      });
    } else {
      this.showViewer = false;
    }
  };

  deleteUnsavedAttachment(file) {
    var index = this.newFiles.indexOf(file);
    this.newFiles.splice(index, 1);
  }

  upload() {
    this.fileData = [];
    var currentUpload = this.formData.fileDrop;
    this.formData.fileDrop = [];
    this.openModal();
    for (var i = 0; i < currentUpload.length; i++) {
      currentUpload[i].nameEdit = "";
      for (var y = 0; y < currentUpload[i].name.substr(0, currentUpload[i].name.lastIndexOf('.') + 1).length; y++) {
        if (currentUpload[i].name[y] !== " " && currentUpload[i].name[y] !== "&" && currentUpload[i].name[y] !== "*" && currentUpload[i].name[y] !== ":" &&
          currentUpload[i].name[y] !== ";" && currentUpload[i].name[y] !== "|" && currentUpload[i].name[y] !== "=" && currentUpload[i].name[y] !== "," &&
          currentUpload[i].name[y] !== "." && currentUpload[i].name[y] !== "/" && currentUpload[i].name[y] !== "\"" && currentUpload[i].name[y] !== "[" &&
          currentUpload[i].name[y] !== "]")
          currentUpload[i].nameEdit += currentUpload[i].name[y];
      }
      currentUpload[i].nameEdit += currentUpload[i].name.substr(currentUpload[i].name.lastIndexOf('.'), currentUpload[i].name.length);
    }

    if (currentUpload !== null) {
      for (var i = 0; i < currentUpload.length; i++) {
        var preLoad = 0;
        this.readFile(currentUpload[i], (e, filename: string) => {
          setTimeout(() => {
            this.fileData.push({ data: e.target.result.toString().split(","), size: e.total, name: filename });
            if (preLoad === (currentUpload.length - 1)) {
              this.fileData.forEach((val: any) => {
                currentUpload.forEach((val2: any) => {
                  if (val2.size === val.size && val.name === val2.name) {
                    this.newFiles.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split("/")[0] });
                  }
                });
              });
              if (this.ExpenseItemID != -1)
                this.attachmentUpload(this.ExpenseItemID, '');
              else
                this.blurSave();
            }
            preLoad++;
          });
        });
      };
    }
    this.closeModal();
  }

  fadeLabel(status: any) {
    this.formData.labelFade = false;
    this.formData.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }

  attachmentUpload(ID: any, close: string) {
    this.openModal();
    this.close = close;
    this.formData.disableButton = true;
    this.innerCounter = 0;
    if (this.newFiles.length > 0) {
      this.newFiles.forEach((attachment: any) => {
        if (attachment.Progress != 100) {
          if (attachment.File != null && attachment.Filename != null) {
            this.showSaved = true;
            this.attachmentList.push({ ExpenseAttachmentID: ID, FileAttachmentID: '', AttachmentFileName: attachment.Filename, AttachmentFileData: attachment });
            this.savedFiles.push({ ExpenseAttachmentID: ID, FileAttachmentID: '', AttachmentFileName: attachment.Filename, AttachmentFileData: attachment });
            this.showPending = false;
            this.showSaved = true;
            this.HttpClient.request(new HttpRequest(
              'POST',
              "/employee/AddAttachmentToLine",
              { expenseItemID: ID, photoFileData: attachment.File, photoFileType: attachment.Filename }, {
              reportProgress: true
            })).subscribe((event: HttpEvent<any>) => {
              switch (event.type) {
                case HttpEventType.UploadProgress:
                  attachment.Progress = Math.round(event.loaded / event.total * 100);
                  if (attachment.Progress == 100) {
                    attachment.AttchDone = true;
                  }
                  break;
                case HttpEventType.Response:
                  this.innerCounter++;
                  this.checkAttachmentInfo();
                  attachment.Filedata.result = event.body;
              }
            },
              error => this.errorMsg = error.message
            )
          }
        }
      });
    }
  }

  checkAttachmentInfo() {
    if (this.innerCounter == this.newFiles.length && this.innerCounter != 0) {
      this.cleanBoard = false;
      var attachTF = true;
      var error = "";
      this.newFiles.forEach((val2: any) => {
        if (val2.Progress != 100 && val2.FileName != null)
          attachTF = false;
      });
      if (attachTF) {
        this.newFiles = [];
        this.formData.fileDrop = null;
        if (this.close == "close") {
          this.closeModal();
        }
        else
          this.getAttachment();
      } else {
        this.alert = "Failed to save one or more attachments - " + error;
      }
    }
  }

  fieldChanged(field: any) {
    if (field.ColumnName === "JCCo") {
      this.formData.jobTemp = null;
      this.formData.jobTempName = null;
      this.formData.phaseTemp = null;
      this.formData.phaseTempName = null;
    }
    if (field.ColumnName === "EMCo") {
      this.formData.equipTemp = null;
      this.formData.equipTempName = null;
      this.formData.woTemp = null;
      this.formData.woTempName = null;
      this.comboFocused("EMCo", null);
    }
    if (field !== null) {
      switch (field.ColumnName) {
        case "ItemType":
          this.getPOFields('');
          break;
        case "JCCo":
          this.itemDetails.Job = null;
          this.lookupValues.Job = [];
          this.lookupLoaded.Job = false;
          this.itemDetails.Phase = null;
          this.lookupValues.Phase = [];
          this.lookupLoaded.Phase = false;
          this.formData.phaseTemp = null;
          this.formData.phaseTempName = null;
          this.itemDetails.JCCType = null;
          this.lookupValues.JCCType = [];
          this.lookupLoaded.JCCType = false;
          this.formData.selectedPayApp = null;
          this.comboFocused("Job", null);
          break;
        case "Equip":
          this.itemDetails.Equip = this.formData.equipTemp;
          break;
        case "GLCo":
          this.itemDetails.GLAcct = null;
          this.lookupValues.GLAcct = [];
          this.lookupLoaded.GLAcct = false;
          this.comboFocused("GLAcct", null);
          break;
        case "Job":
          this.itemDetails.Job = this.formData.jobTemp;
          this.itemDetails.Phase = null;
          this.lookupValues.Phase = [];
          this.lookupLoaded.Phase = false;
          this.formData.phaseTemp = null;
          this.formData.phaseTempName = null;
          this.itemDetails.JCCType = null;
          this.lookupValues.JCCType = [];
          this.lookupLoaded.JCCType = false;
          this.formData.selectedPayApp = null;
          break;
        case "Phase":
          this.lookupValues.JCCType = [];
          this.lookupLoaded.JCCType = false;
          this.loadValues("JCCType", null, null, null, null);
          if (!this.lookupValues.JCCType || this.lookupValues.JCCType.length == 0 || !this.checkForJCCType(this.itemDetails.JCCType)) {
            this.itemDetails.JCCType = null;
          }
          break;
        case "PO":
          this.lookupLoaded["POItem"] = false;
          this.lookupValues["POItem"] = [];
          this.itemDetails.POItem = null;
          this.lookupLoaded["POItemLine"] = false;
          this.lookupValues["POItemLine"] = [];
          this.itemDetails.POItemLine = null;
          this.comboFocused("POItem", true);
          break;
        case "POItem":
          this.lookupLoaded["POItemLine"] = false;
          this.lookupValues["POItemLine"] = [];
          this.itemDetails.POItemLine = null;
          this.comboFocused("POItemLine", true);
          break;
        case "POItemLine":
          this.getFieldValuesByPOItem();
          break;
        case "EMCo":
          this.itemDetails.EMCType = null;
          this.lookupValues.EMCType = [];
          this.lookupLoaded.EMCType = false;
          this.itemDetails.WO = null;
          this.lookupValues.WO = [];
          this.formData.woTemp = null;
          this.lookupLoaded.WO = false;
          this.itemDetails.WOItem = null;
          this.lookupValues.WOItem = [];
          this.lookupLoaded.WOItem = false;
          this.itemDetails.Equipment = null;
          this.lookupValues.Equipment = [];
          this.lookupLoaded.Equipment = false;
          this.itemDetails.CostCode = null;
          this.lookupValues.CostCode = [];
          this.lookupLoaded.CostCode = false;
          break;
        case "WO":
          this.itemDetails.WO = this.formData.woTemp;
          this.itemDetails.WOItem = null;
          this.lookupValues.WOItem = [];
          this.lookupLoaded.WOItem = false;
          break;
        case "SMWorkOrder":
          this.itemDetails.SMWorkOrder = this.formData.smWorkOrderTemp;
          this.itemDetails.Scope = null;
          this.lookupValues.Scope = [];
          this.lookupLoaded.Scope = false;
          break;
        case "Material":
          this.itemDetails.Material = this.formData.materialTemp;
          this.formData.UM = null;
          this.lookupValues.UM = [];
          this.lookupLoaded.UM = false;
          break;
        //SL fields
        case "SL":
          this.itemDetails.SLItem = null;
          this.lookupValues.SLItem = [];
          this.lookupLoaded.SLItem = false;
          break;
        case "SLItem":
          //getSLDefaults();
          break;
        case "CostCode":
          this.itemDetails.EMCType = null;
          this.lookupValues.EMCType = [];
          this.lookupLoaded.EMCType = false;
      }
    }
    this.willSave();

    if (this.canSave) {
      this.blurSave();
    }
  }

  comboFocused(columnName: string, selectFirst: boolean) {
    if ((this.lookupValues[columnName] === null || this.lookupValues[columnName] === undefined || this.lookupValues[columnName].length === 0)) {
      this.loadValues(columnName, selectFirst, null, null, null);
    }
  }

  getFieldValuesByPOItem() {
    if (this.itemDetails.PO != null && this.itemDetails.POItem != null && this.itemDetails.POItemLine != null) {
      var tempPOCo = null;
      this.lookupValues["PO"].forEach((val: any) => {
        if (val.DatabaseValue == this.itemDetails.PO) {
          tempPOCo = val.POCo;
        }
      })

      this.employeeService.getFieldValuesByPOItem(this.itemDetails.PO, this.itemDetails.POItem, this.itemDetails.POItemLine, tempPOCo).then((response: any) => {
        this.bindPOValues(response);
      });
    }
  }

  checkForJCCType(jccTypeId: any) {
    var isInJCCType = false;
    this.lookupValues.JCCType.forEach((value: any) => {
      if (parseInt(value.DatabaseValue) === parseInt(jccTypeId)) {
        isInJCCType = true;
      }
    });
    return isInJCCType;
  }

  willSave() {
    this.canSave = true;
    if (this.typeFields != null && this.typeFields.form.invalid) {
      for (let item in this.itemDetailsCheck) {
        if (this.itemDetailsCheck[item] && !this.itemDetails[item]) {
          this.canSave = false;
        }
      }
    }
  }

  switchEditImage() {
    this.disableSaveImage = true;
    this.enableEditImage = false;
    this.editNow = !this.editNow;
    if (this.editNow) {
      this.getAttachmentList();
    } else {
      this.getAttachment();
    }
  }

  getAttachmentList() {
    this.employeeService.getLineAttachments(this.ExpenseItemID).then((response: any) => {
      response = this.orderByPipe.transform(response, "AttachmentFileName", "asc");
      this.attachmentList = [];
      response.forEach((val: any) => {
        var tempExten = val.AttachmentFileName.substr(val.AttachmentFileName.lastIndexOf("."), val.AttachmentFileName.length);
        if (tempExten.toLowerCase() == ".jpg" || tempExten.toLowerCase() == ".jpeg" || tempExten.toLowerCase() == ".png" || tempExten.toLowerCase() == ".tif" || tempExten.toLowerCase() == ".tiff")
          this.attachmentList.push(val);
      });
      if (this.attachmentList.length > 0) {
        this.formData.selectedAttachment = this.attachmentList[0];
        this.getImageData();
      }
    });
  }

  deleteSavedAttachment(data: any) {
    this.employeeService.removeAttachment(data.ExpenseAttachmentID).then((response: any) => {
      this.openModal();
      this.getAttachment();
      this.cleanBoard = false;
    });
  };

  getImageData() {
    this.openModal();
    this.employeeService.getRawAttachmentData(this.formData.selectedAttachment.FileAttachmentID, true).then((response: any) => {
      this.uploadImage = ("data:image/png;base64," + (response));
      this.imageSrc = this.uploadImage;
      this.closeModal();
    });
  }


  //Image Cropping
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  applyRotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  applyRotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }


  restartJcrop() {
    this.canvasRotation = 0;
    this.croppedImage = null;
    this.transform = {};
    this.imageSrc = this.uploadImage;
    this.closeModal();
  }

  cancelCrop() {
    this.openModal();
    this.enableEditImage = false;
    this.restartJcrop();
  }


  allowCropping() {
    this.enableEditImage = true;
    this.restartJcrop();
  }

  saveEdit() {
    this.disableSaveImage = false;
    this.openModal();

    this.employeeService.removeAttachment(this.formData.selectedAttachment.ExpenseAttachmentID).then((response: any) => {
      this.employeeService.addAttachmentToLine(this.ExpenseItemID, this.croppedImage.split(",")[1], this.formData.selectedAttachment.AttachmentFileName).then((response: any) => {
        this.enableEditImage = false;
        if (this.editNow) {
          this.getAttachmentList();
        } else {
          this.getAttachment();
        }
        this.disableSaveImage = true;
        this.closeModal();

        this.restartJcrop();
        this.cleanBoard = false;
      });
    });

  }

  grabURI() {
    this.openModal();
    this.employeeService.removeAttachment(this.formData.selectedAttachment.ExpenseAttachmentID).then((response: any) => {
      this.employeeService.addAttachmentToLine(this.ExpenseItemID, this.croppedImage.split(",")[1], this.formData.selectedAttachment.AttachmentFileName).then((response: any) => {
        this.closeModal();
        this.cleanBoard = false;
        this.switchEditImage();
      });
    });
  }

  getLargeLookupValues(columnName: string, temp: any, tempName: any) {
    this.itemDetails[columnName] = this.formData[temp];
    if (this.formData[tempName] !== null && this.formData[tempName].length > 2) {
      this.loadValues(columnName, false, this.formData[tempName], true);
    }
    this.willSave();
  };

  saveClicked() {
    this.saveItem('close');
  };

  saveAndSubmitClicked() {
    this.saveItem('submit');
  };

  earnCodeChanged() {
    this.willSave();
    if (this.canSave) {
      this.blurSave();
    }
  }
  
  taxTypeChange() {
    if (this.formData.TaxType == 0) {
      this.formData.TaxCode = null;
      this.taxCodeList = [];
    } else {
      this.getTaxCode();
    }
  }

  umChange() {
    if (this.formData.UM !== "LS") {
      this.formData.Amount = null;
      this.formData.TaxCode = null;
      this.formData.TaxAmount = null;
    } else {
      this.formData.Units = null;
      this.formData.UnitCost = null;
    }
  }

  openModal() {
    document.getElementById('modalShare').style.display = 'block';
    document.getElementById('fadeShare').style.display = 'block';
  }

  closeModal() {
    document.getElementById('modalShare').style.display = 'none';
    document.getElementById('fadeShare').style.display = 'none';
  }
}